// eslint-disable-next-line import/prefer-default-export
export const displayTexts = [
  'Segurança e \n simplicidade para gerenciar suas compras',
  'Transparências nas suas parcelas para você ficar tranquilo',
  'Parcele suas compras onlines em até \n 24 vezes',
  'Sua avaliação de crédito não foi aprovada no momento. Mas não se preocupe, você pode tentar novamente no futuro.',
  'Não desanime, você ainda pode comprar através de outros meios de pagamento em nossos parceiros',
];
